module.exports = __webpack_public_path__ + "img/13.b756dc31.png";